import { useContext } from 'react'
import { TableContext } from '../providers/TableFiltersProvider'

export const useTableParams = () => useContext(TableContext)!
